"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasWindow = typeof window !== 'undefined';
var CoreEvents = {
    on: function (eventName, handler) {
        if (!hasWindow)
            return false;
        return window.addEventListener(eventName, handler);
    },
    emit: function (eventName, eventDetails) {
        var event = new CustomEvent(eventName, {
            detail: eventDetails
        });
        return hasWindow && window.dispatchEvent(event);
    },
    off: function (eventName, handler) {
        if (!hasWindow)
            return false;
        return window.removeEventListener(eventName, handler);
    }
};
exports.default = CoreEvents;
